/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jan 17 2024
 **/

import styled from "@emotion/styled";

import Vote from "./Vote";

type RenderItemProps = ChatServices.Format2.Elements.AllVoteElements & {
	isFile?: boolean;
	single?: boolean;
};

export default function RenderVoteItem(
	props: RenderItemProps & { onClick?: (item: ChatServices.Format2.Elements.AllVoteElements) => void }
) {
	return (
		<div>
			<Vote
				vote={props.vote}
				roomID={props.roomId}
				spaceID={props.spaceId}
				voteType={props.content.elements?.[0]?.key}
			/>
		</div>
	);
}
const emojiRegex = /^(\p{Emoji_Presentation}|\p{Emoji}\uFE0F|\u200D)+$/u;
const StyledWrapper = styled.div<{ type: ChatServices.Format2.Elements.AllTypes; text?: string }>`
	font-size: ${({ type, text }) => {
		if (type === "text" && !text) return 15;
		if (type === "text" && text && emojiRegex.test(text)) return "36px";
		return "15px";
	}};
	margin-top: ${({ type, text }) => {
		if (type === "text" && text && emojiRegex.test(text)) return "8px";
		return 0;
	}};
	width: ${({ type }) => {
		switch (type) {
			case "image": {
				return null;
			}
			default: {
				return "100%";
			}
		}
	}};
	max-width: ${({ type }) => {
		switch (type) {
			case "file": {
				return "280px";
			}
			default: {
				return "100%";
			}
		}
	}};
`;
